<template>
    <div>

        <section class="pt-10 pb-11 py-md-14 overlay overlay-black overlay-60 jarallax doc-img" data-jarallax data-speed=".8">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center">

                        <!-- Heading -->
                        <h1 class="display-2 font-weight-bold text-white">
                            What Do You Need?
                        </h1>

                        <!-- Text -->
                        <p class="lead text-white-75 mb-0">
                            We're here to help you better use Landkit. First, let's figure out if we have a solution in our documentation.
                        </p>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

        <div class="position-relative">
            <div class="shape shape-bottom shape-fluid-x svg-shim text-light">
                <svg fill="none" viewBox="0 0 2880 48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
                </svg>
            </div>
        </div>

        <section>
            <div class="container">
                <div class="row">
                    <div class="col-12">

                        <!-- Form -->
                        <form class="rounded shadow mt-n6 mb-4">
                            <div class="input-group input-group-lg">

                                <!-- Prepend -->
                                <div class="input-group-prepend">
                  <span class="input-group-text border-0 pr-1">
                    <i class="fe fe-search"/>
                  </span>
                                </div>

                                <!-- Input -->
                                <input aria-label="Search for your issue..." class="form-control border-0 px-1" placeholder="Search for your issue..." type="text">

                                <!-- Append -->
                                <div class="input-group-append">
                  <span class="input-group-text border-0 py-0 pl-1 pr-3">
                    <button class="btn btn-sm btn-primary" type="submit">
                      Search
                    </button>
                  </span>
                                </div>

                            </div>
                        </form>

                        <!-- Text -->
                        <div class="row align-items-center mb-6 mb-md-8">
                            <div class="col-auto">

                                <!-- Heading -->
                                <h6 class="font-weight-bold text-uppercase text-muted mb-0">
                                    Common searches:
                                </h6>

                            </div>
                            <div class="col ml-n5">

                                <!-- Text -->
                                <p class="font-size-sm text-muted mb-0">
                                    Redownload my theme, Request an invoice, Update my .zip
                                </p>

                            </div>
                        </div> <!-- / .row -->

                    </div>
                </div> <!-- / .row -->
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-primary shadow-lg mb-6 mb-md-8 lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-primary text-white mb-5">
                                    <i class="fe fe-users"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Account
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Issues related to logging in, out, or about multiple devices.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    21 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-success shadow-lg mb-6 mb-md-8 lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-success text-white mb-5">
                                    <i class="fe fe-clock"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Integrations
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Connecting with 3rd party apps to exchange data.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    9 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-warning shadow-lg mb-6 mb-md-8 lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-warning text-white mb-5">
                                    <i class="fe fe-users"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Billing
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Issues with payments or invoicing.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    14 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-dark shadow-lg mb-6 mb-md-8 mb-lg-0 lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-dark text-white mb-5">
                                    <i class="fe fe-users"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Organizations
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Setting up and managing collections of users.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    17 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-primary-desat shadow-lg mb-6 mb-md-0 lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-primary-desat text-white mb-5">
                                    <i class="fe fe-users"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Performance
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Improving your system's speed and reliability.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    7 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 col-lg-4">

                        <!-- Card -->
                        <div class="card card-border border-danger shadow-lg lift lift-lg">
                            <div class="card-body text-center">

                                <!-- Icon -->
                                <div class="icon-circle bg-danger text-white mb-5">
                                    <i class="fe fe-users"/>
                                </div>

                                <!-- Heading -->
                                <h4 class="font-weight-bold">
                                    Customizing
                                </h4>

                                <!-- Text -->
                                <p class="text-gray-700 mb-5">
                                    Building custom modules on top of our platform.
                                </p>

                                <!-- Badge -->
                                <span class="badge badge-pill badge-dark-soft">
                  <span class="h6 text-uppercase">
                    14 entries
                  </span>
                </span>

                            </div>
                        </div>

                    </div>
                </div> <!-- / .row -->
            </div>
        </section>

        <section class="pt-8 pt-md-11 pb-8 pb-md-14">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center">

                        <!-- Heading -->
                        <h2 class="font-weight-bold">
                            Can't find the answer you need?
                        </h2>

                        <!-- Text -->
                        <p class="font-size-lg text-muted mb-7 mb-md-9">
                            Contact us and we'll get back to you as soon as possible with a solution to whatever issues you're having with Landkit.
                        </p>

                    </div>
                </div> <!-- / .row -->
                <div class="row mb-7 mb-md-9">
                    <!--                    <div class="col-12 col-md-4 text-center">-->

                    <!--                        &lt;!&ndash; Heading &ndash;&gt;-->
                    <!--                        <h6 class="text-uppercase text-gray-700 mb-1">-->
                    <!--                            Message us-->
                    <!--                        </h6>-->

                    <!--                        &lt;!&ndash; Link &ndash;&gt;-->
                    <!--                        <div class="mb-5 mb-md-0">-->
                    <!--                            <a class="h4 text-primary" href="#!">-->
                    <!--                                Start a chat!-->
                    <!--                            </a>-->
                    <!--                        </div>-->

                    <!--                    </div>-->
                    <div class="col-12 col-md-6 text-center">

                        <!-- Heading -->
                        <h6 class="text-uppercase text-gray-700 mb-1">
                            Call anytime
                        </h6>

                        <!-- Link -->
                        <div class="mb-5 mb-md-0">
                            <a class="h4" href="#!">
                                +31 (0)70 808 0191
                            </a>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 text-center border-left-md border-gray-300">

                        <!-- Heading -->
                        <h6 class="text-uppercase text-gray-700 mb-1">
                            Email us
                        </h6>

                        <!-- Link -->
                        <a class="h4" href="#!">
                            connect@qlikchain.com
                        </a>

                    </div>
                </div> <!-- / .row -->
                <div class="row justify-content-center">
                    <div class="col-12">

                        <!-- Form -->
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-5">

                                        <!-- Label -->
                                        <label for="contactName">
                                            Full name
                                        </label>

                                        <!-- Input -->
                                        <input class="form-control" data-vv-as="Full Name" id="contactName" name="name" placeholder="Full name" type="text" v-model="docs_form.name"
                                               v-validate="'required'">
                                        <div class="text-danger" v-if="submitted && errors.has('name')">{{ errors.first('name') }}</div>

                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-5">

                                        <!-- Label -->
                                        <label for="contactEmail">
                                            Email
                                        </label>

                                        <!-- Input -->
                                        <input class="form-control" data-vv-as="Email" id="contactEmail" name="email" placeholder="hello@domain.com" type="email" v-model="docs_form.email"
                                               v-validate="'required|email'">
                                        <div class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                                    </div>
                                </div>
                            </div> <!-- / .row -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-7 mb-md-9">

                                        <!-- Label -->
                                        <label for="contactMessage">
                                            What can we help you with?
                                        </label>

                                        <!-- Input -->
                                        <textarea class="form-control" data-vv-as="Contact Message" id="contactMessage" name="msg" placeholder="Tell us what we can help you with!" rows="5"
                                                  v-model="docs_form.msg" v-validate="'required'"/>
                                        <div class="text-danger" v-if="submitted && errors.has('msg')">{{ errors.first('msg') }}</div>
                                    </div>
                                </div>
                            </div> <!-- / .row -->
                            <div class="row justify-content-center">
                                <div class="col-auto">

                                    <!-- Submit -->
                                    <button class="btn btn-success lift" type="submit">
                                        Send message
                                    </button>

                                </div>
                            </div> <!-- / .row -->
                        </form>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

    </div>
</template>

<script>
    export default {
        name: "Documentation",
        data() {
            return {
                submitted: false,
                docs_form: {
                    name: null,
                    email: null,
                    msg: null
                }
            }
        },
        methods: {
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    console.log('valid : ', valid);
                    if(valid) {
                        this.save();
                    }
                });
            },
            async save() {
                console.log('ok');
                console.log(this.sales_form);
            }
        }
    }
</script>

<style scoped>
    .doc-img {
        background-image: url(../../assets/img/covers/cover-4.jpg);
    }
</style>
